module.exports = __webpack_public_path__ + "static/Thumb_MM_S10_Zoom_MM-57ef4ddd4ca7dc396d295204c7422a08.png";